import { memo, useCallback, useRef, useState } from 'react'
import { Col, Row } from 'react-grid-system'
import textsData from '@/textData/UserProfileTexts.json'
import { useUserLanguage } from '@/customHooks'
import {
  NormalFormPasswordField,
} from '../molecules'
import { ChangePasswordData } from '@/custom-types'
import { RowSpacer } from '../atoms'

type ProfileChangePasswordFormControlledProps = {
  onChange: (passwordData: ChangePasswordData) => void
}

type ChangePasswordInternalData = {
  oldPassword: string,
  newPassword: string,
  newPasswordConfirmation: string,
}

const MIN_PASWORD_LENGTH = 8;

const emptyData: ChangePasswordInternalData = {
  oldPassword: '',
  newPassword: '',
  newPasswordConfirmation: '',
}

export const  ProfileChangePasswordFormControlled = memo(({ onChange }: ProfileChangePasswordFormControlledProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.changePassword : textsData.en.changePassword

  const [passwordWarn, setPasswordWarn] = useState<boolean>(false)
  const passwordDataRef = useRef<ChangePasswordInternalData>(emptyData)

  const onFieldChangeHandle = useCallback((field: keyof ChangePasswordInternalData, value: string | null) => {
    if (!value) return

    passwordDataRef.current = {
      ...passwordDataRef.current,
      [field]: value 
    }

    if (passwordDataRef.current.newPassword === passwordDataRef.current.newPasswordConfirmation) {
      setPasswordWarn(false)
    } else {
      setPasswordWarn(true)
    }

    if (
      (passwordDataRef.current.oldPassword.length >= MIN_PASWORD_LENGTH &&
      passwordDataRef.current.newPassword.length >= MIN_PASWORD_LENGTH &&
      passwordDataRef.current.newPasswordConfirmation.length >= MIN_PASWORD_LENGTH) &&
      (passwordDataRef.current.newPassword === passwordDataRef.current.newPasswordConfirmation)
    ) {
      onChange({
        newPassword: passwordDataRef.current.newPassword,
        currentPassword: passwordDataRef.current.oldPassword
      })
    }
  }, [onChange])

  return (
    <>
      <Row>
        <Col>
          <NormalFormPasswordField
            name="oldPassword"
            label={texts.currentPassword.label}
            placeholder={texts.currentPassword.placeholder}
            onChange={(value) => onFieldChangeHandle('oldPassword', value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormPasswordField
            name="newPassword"
            label={texts.newPassword.label}
            placeholder={texts.newPassword.placeholder}
            onChange={(value) => onFieldChangeHandle('newPassword', value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormPasswordField
            name="newPasswordConfirmation"
            label={texts.confirmNewPassword.label}
            placeholder={texts.confirmNewPassword.placeholder}
            onChange={(value) => onFieldChangeHandle('newPasswordConfirmation', value)}
          />
        </Col>
      </Row>
      <RowSpacer height={2} />
      <Row>
        <Col>
          {
            passwordWarn
            ? <p>Passwords have to be equal</p>
            : null
          }
        </Col>
      </Row>
    </>
  )
})
